import { Box, Button, Divider, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReactSelect from 'react-select'
import { createSupplyPermit} from '../../redux/actions/tanks/tanksAction'
import InfoIcon from '@material-ui/icons/Info';

export const AssignTank = ({ close, data, station }) => {
  const { selectUnitToAssing, tanks } = useSelector(state => state.tanks)
  const { tanks: tanksUnit, id } = selectUnitToAssing
  const { token } = useSelector(state => state.login)
  const dispatch = useDispatch()
  const select = data ? data.map(obj => {
    return {
      ...obj,
      label: `${obj.name} - ${obj.type}`
    }
  }): []
  const [adding, setAdding] = useState( tanksUnit ? tanksUnit.map(tk => {
    return {
      value: tanks[tk].id,
      label: `${tanks[tk].name} - ${tanks[tk].type}`
    }
  }) : [])
  const [tankInfo, setTankInfo] = useState()

  const handleAssignTank = (values) => {
    setAdding(values === null ? [] : values)
  }

  const handleTankInfo = (tank) => {
    setTankInfo(tanks[tank])
  }


  
  const handleSubmitCreatePermit = () => {
    if(adding.length > 0) {
      const idTanks = adding.map(item => item.value)
      const form = {
        id_unit: id,
        id_tanks: idTanks //[2]
      }
      dispatch(createSupplyPermit (form, token, station))
      close()
    } else if(adding.length === 0){
      const form = {
        id_unit: id,
        id_tanks: []
      }
      dispatch(createSupplyPermit (form, token, station))
      close()
    }
    

  }

  const handleDeleteAll = () => {
    setAdding([])
  }
  
  return (
    <Box>
      <Typography id="modal-modal-title" variant="h6" component="h2">
      </Typography>
      <ReactSelect
        isMulti
        label="Tanques"
        placeholder="Asigne tanque"
        value={adding}
        options={select}
        onChange={(e) => handleAssignTank(e)}
        className="list-select__container "
        classNamePrefix="select"
      />
      
      <Box style={{
        width: '100%',
        padding: 10,
        borderRadius: 5,
        marginTop: 50,
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}>
        {
          adding.length > 0 
          ? adding.map(item => (
            <Button
              key={item.value} 
              variant="outlined"
              startIcon={<InfoIcon />}
              onClick={() => handleTankInfo(item.value)}
              color="primary"
              style={{ marginRight: 15 }}
            >{item.label}</Button>
          ))

          : <Typography variant="body2" component="h2" >
              No hay tanques asignados
            </Typography>
        }
      </Box>

      { adding.length > 0 && <Divider />}
      {
        tankInfo &&
        <Box style={{ 
          margin: 15,
          marginTop: 30
        }}>
          <Typography color="primary" align="center"
          variant="subtitle1">{ tankInfo?.name }</Typography>
          <Box style={{ 
          display: 'flex',
          justifyContent: 'center',
        }}>
            <Typography color="primary" style={{marginRight: 15}} variant="body1">Latitud: { tankInfo?.latitude }</Typography>
            <Typography color="primary" style={{marginRight: 15}} variant="body1">Longitud {  tankInfo?.longitude }</Typography>
            <Typography color="primary" style={{marginRight: 15}} variant="body1">Capacidad: { tankInfo?.capacity }</Typography>
          </Box>
        </Box>
      }
      {
        adding.length > 0 && <Typography variant="subtitle2" component="h3" align="right" color="textSecondary" style={{margin: '30px 0'}}>Tanques asignados: {adding.length}</Typography>
      }
      <Box style={{
        float: 'right',
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap'
      }}>
        <Button variant="contained" color="secondary" onClick={close}style={{margin: 5}} 
        >Cancelar</Button>
        <Button variant="outlined" color="secondary" style={{margin: 5}} 
          onClick={handleDeleteAll}
        >Borrar todos</Button>
        <Button variant="contained" color="primary" style={{margin: 5}} 
          onClick={handleSubmitCreatePermit}
          >Guardar</Button>
      </Box>
    </Box>
  )
}
